import {
  FlexBox,
  JoonUIColor,
  Loader,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

const CreatingAccount = () => {
  const { t } = useTranslation()
  return (
    <FlexBox
      direction="column"
      wrap={false}
      justify="center"
      align="center"
      style={{ height: "80dvh" }}
      gap={SPACING.space2}
    >
      <img
        style={{ height: "150px" }}
        src={"/images/chibi_polair.svg"}
        alt="polair"
      />
      <Typography
        variant="h2Serif"
        textAlign="center"
        style={{ marginBottom: SPACING.space4 }}
      >
        {t("ONBOARDING_CREATING_ACCOUNT")}
      </Typography>
      <Loader color={JoonUIColor.background.accent} size={32} thickness={4} />
    </FlexBox>
  )
}

export default CreatingAccount
